<template>
  <div>
    <div v-if="!loading" class="main" :style="style">
      <Header title="Centro" titleColor="white" />
      <section class="content">
        <EditCenter
          v-if="showEdit"
          class="mb-4"
          :info="info"
          @edit="openEditar"
          @toggleStatus="handleStatus"
        />

        <div v-if="!notFound.show">
          <v-row>
            <v-col cols="12" class="pt-0">
              <div v-if="!notFound.show" class="solution">
                <div v-if="!edit.show">
                  <!-- DISPLAY SOLUTION -->
                  <p class="text-h6">Solução Alocada</p>
                  <p v-if="notPublished">
                    A alocação não está disponível.
                  </p>
                  <PaasSolution
                    :key="componentKey"
                    v-if="!loading && !notPublished"
                    :plan="solution"
                    occupancyRate
                    searchEmptyRoom
                  />
                </div>

                <div v-if="edit.show">
                  <EditSolution
                    :solution="solution"
                    :back="() => (edit.show = false)"
                    :save="handleEditPublicSolution"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="notFound.show" class="solution pt-16">
          <NotFound
            class="pt-16"
            :title="notFound.title"
            :text="notFound.text"
          />
        </div>
      </section>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import PaasSolution from "@/components/paas/PaasSolution.vue";
import Header from "@/components/Header.vue";
import Loading from "@/components/Loading.vue";
import NotFound from "@/components/NotFound.vue";
import EditSolution from "@/components/paas/EditSolution.vue";
import EditCenter from "@/handles/paas/center/EditCenter.vue";

import {
  getCenterInfo,
  editPaasSolutionCenter
} from "@/api/paas/center";

export default {
  name: "PaasPublicar",
  components: {
    Header,
    PaasSolution,
    Loading,
    NotFound,
    EditSolution,
    EditCenter
  },
  data() {
    return {
      componentKey: 0,
      solution: [],
      info: {
        id: "",
        centro: "",
        date: "",
        description: "",
        link: "",
        status: ""
      },
      loading: true,
      found: false,
      notPublished: false,
      notFound: {
        show: false,
        title: "Eita! Parece que não há uma alocação pública.",
        text:
          "Tente simular uma alocação. Após o resultado, clique em publicar solução."
      },
      edit: {
        show: false
      }
    };
  },
  computed: {
    style() {
      return `${
        this.$vuetify.breakpoint.width > 1920
          ? `width: ${Math.floor(
              1920 + (this.$vuetify.breakpoint.width - 1920) / 2
            )}px;`
          : "width: 100%;"
      }`;
    },
    showEdit() {
      return this.$store.getters.getAllow(3);
    }
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Paas"
    });
  },

  methods: {
    handleStatus(status = this.info.status) {
      switch (status) {
        //if is published
        case "published":
          this.found = true;
          this.notPublished = false;
          this.notFound.show = false;
          break;
        //if academic center exists, but there is no solution
        case "not-published":
          this.found = false;
          this.notPublished = true;
          this.notFound.show = false;
          break;
        //if academic center is not found
        default:
          this.found = false;
          this.notPublished = false;
          this.notFound.show = true;
          break;
      }
      this.componentKey += 1;
    },
    handleEditPublicSolution(salas, turmas) {
      editPaasSolutionCenter(salas, turmas).then(() => {
        this.$router.go();
      });
    },
    async init() {
      let center = this.$store.getters.getCentro;
      this.info.link = `/salas/${center}`.toLocaleLowerCase();

      getCenterInfo(center)
        .then(res => {
          this.info.centro = res.centro;
          this.info.description = res.description;
          this.info.date = res.date;
          this.info.id = res.id;
          this.info.status = res.status;
          this.solution = res.solution;
          this.handleStatus(res.status);
        })
        .catch(() => {
          this.notFound.show = true;
        })
        .finally(() => {
          this.loading = false;
          this.componentKey += 1;
        });
    },
    openEditar() {
      if (!this.notPublished) this.edit.show = true;
    }
  },

  async mounted() {
    await this.init();
  }
};
</script>

<style scoped>
.main {
  background: rgb(71, 118, 230);
  /* background: linear-gradient(50deg, rgba(71,118,230,1) 0%, rgba(142,84,233,1) 100%); */
  background: linear-gradient(135deg, #1491ff, #0346b6);
  min-height: 100vh;
}

.content {
  /* margin: auto; */
  max-width: 1600px;
  left: 0;
}

.solution {
  padding: 40px;
  border-radius: 15px;
  margin: 0 10px 0 20px;
  min-height: 90vh;
  background-color: white;
}

.center {
  height: 200px;
}
</style>
